import { render, staticRenderFns } from "./CommandButton.vue?vue&type=template&id=2b783300&scoped=true"
import script from "./CommandButton.vue?vue&type=script&lang=js"
export * from "./CommandButton.vue?vue&type=script&lang=js"
import style0 from "./CommandButton.vue?vue&type=style&index=0&id=2b783300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b783300",
  null
  
)

export default component.exports